import { useMemo } from 'react';
import { Accordion } from 'react-bootstrap';
import { CommonProperties, MissionControlOrderDataBlob } from '../../common/common.interfaces';
import { EpicOrderDetails } from '../epicOrders.interfaces';

interface EpicOrdersImportReviewProps extends CommonProperties {
  mappedOrders: MissionControlOrderDataBlob[] // successfully mapped to MC format
  failedOrders: EpicOrderDetails[] // can only be parsed as original excel format
} 
export default function EpicOrdersImportReview (
  props : EpicOrdersImportReviewProps
){ 

  // #region VIEW
  const view = useMemo(() => {
    
    let mappedDivs = []
    let failedDivs = []
    if (props.mappedOrders) {
      props.mappedOrders.map((order) => (
        mappedDivs.push(
          <Accordion className='custom-accordion'>
            <Accordion.Item eventKey='0'>
            <div style={{wordBreak: 'break-all', whiteSpace: 'pre-wrap'}} className="review-card">
                <Accordion.Header>Order Name: {order.order.Name}</Accordion.Header>
                <Accordion.Body>{JSON.stringify(order)}</Accordion.Body>
            </div>
            </Accordion.Item>
          </Accordion>
        )
      ))
    }

    if (props.failedOrders) {
      props.failedOrders.map((order) => (
        failedDivs.push(
          <Accordion className='custom-accordion'>
          <Accordion.Item eventKey='0'>
            <div style={{wordBreak: 'break-all', whiteSpace: 'pre-wrap'}}  className="review-card">
            <Accordion.Header>Order Name: {order.orderName}</Accordion.Header>
              <Accordion.Body>
                  <span className='header'>Cause</span>
                  <span className='card'>{order.error}</span>
                  <span className='header'>Contents</span>
                  <span className='card'>{JSON.stringify(order)}</span>
              </Accordion.Body>
              </div>
            </Accordion.Item>         
          </Accordion>
        )
      ))
    }
    
    return <>
      <div style={{display: 'flex'}}>
        {failedDivs.length > 0 &&
          <div className="review-card warning">
            <span className='beacon-header'>FAILED TO MAP [{failedDivs.length} FAILURES]</span>
            <br/>
            <span className='beacon-label'>
              Failures will NOT be included in the import and must be entered manually.
              <br/>
              If an error seems unusual, please contact an administrator.
            </span>
            {failedDivs} 
          </div> 
        }
        {mappedDivs.length > 0 &&
          <div className="review-card success">
            <span className='beacon-header'>READY TO UPLOAD [{mappedDivs.length} ORDERS]</span>
            <br/>
            <span className='beacon-label'>
              It's safe to upload the same order multiple times! 
              <br/>
              After submitting, this list will be cleared.
            </span>
            {mappedDivs} 
          </div> 
        }
      </div>
    </>
  }, [props.mappedOrders, props.failedOrders])

  return view
}
